import { NgModule } from '@angular/core';
import { ChatBotComponent } from './chat-bot.component';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [ChatBotComponent],
  imports: [
    BrowserModule, CommonModule
  ],
  exports: [ChatBotComponent]
})
export class ChatBotModule { }
